export default __webpack_public_path__ + "static/media/Firstmeet4.0a5f6852.jpg";